import React from "react";
import OneSectionDefault from "../oneSection/oneSectionDefault";
// Import Wedding Home Page Images
import wedHomeImg1 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__35mm-film-photography-emotional-vidaai-ceremony-de__4811.webp';
import wedHomeImg2 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__35mm-film-photography-traditional-wedding-mandap-d__4809.webp';
import wedHomeImg3 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__4810.webp';
import wedHomeImg4 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__4812.webp';
import wedHomeImg5 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56971.webp';
import wedHomeImg6 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56972.webp';
import wedHomeImg7 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56973.webp';
import wedHomeImg8 from '../../assets/images/weddingDecoration/WedHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56974.webp';

// Wedding Home Page Data Packages - matched according to image titles
const WeddingHomePageDataPackages = [
    {
      id: 1,
      title: "Bride Welcome Decoration",
      image: wedHomeImg3,
      rating: 4.9,
      reviews: 165,
      currentPrice: 2999,
      originalPrice: 3499,
      discount: 14,
      description: "Beautiful bride welcome setup with flowers and lights",
      subImage: [
        {
          imageOne: wedHomeImg4,
          imageTwo: wedHomeImg5,
          imageThree: wedHomeImg6,
          imageFour: wedHomeImg7,
        }
      ],
    },
    {
      id: 2,
      title: "Haldi Decoration",
      image: wedHomeImg6,
      rating: 4.8,
      reviews: 185,
      currentPrice: 2599,
      originalPrice: 2999,
      discount: 13,
      description: "Traditional haldi ceremony decoration with yellow theme",
      subImage: [
        {
          imageOne: wedHomeImg3,
          imageTwo: wedHomeImg5,
          imageThree: wedHomeImg6,
          imageFour: wedHomeImg8,
        }
      ]
    },
    {
      id: 3,
      title: "Mehndi Decoration",
      image: wedHomeImg5,
      rating: 4.7,
      reviews: 145,
      currentPrice: 2799,
      originalPrice: 3199,
      discount: 12,
      description: "Elegant mehndi ceremony setup with traditional elements",
      subImage: [
        {
          imageOne: wedHomeImg3,
          imageTwo: wedHomeImg4,
          imageThree: wedHomeImg6,
          imageFour: wedHomeImg7,
        }
      ]
    },
    {
      id: 4,
      title: "Wedding Reception Setup",
      image: wedHomeImg6,
      rating: 4.9,
      reviews: 255,
      currentPrice: 3999,
      originalPrice: 4599,
      discount: 13,
      description: "Grand reception decoration with premium arrangements",
      subImage: [
        {
          imageOne: wedHomeImg3,
          imageTwo: wedHomeImg4,
          imageThree: wedHomeImg5,
          imageFour: wedHomeImg8,
        }
      ]
    },
    {
      id: 5,
      title: "Mandap Decoration",
      image: wedHomeImg2,
      rating: 4.8,
      reviews: 195,
      currentPrice: 3499,
      originalPrice: 3999,
      discount: 12,
      description: "Sacred mandap setup with traditional flowers",
      subImage: [
        {
          imageOne: wedHomeImg3,
          imageTwo: wedHomeImg4,
          imageThree: wedHomeImg5,
          imageFour: wedHomeImg6,
        }
      ]
    },
    {
      id: 6,
      title: "Sangam Decoration",
      image: wedHomeImg7,
      rating: 4.9,
      reviews: 175,
      currentPrice: 3299,
      originalPrice: 3799,
      discount: 13,
      description: "Beautiful sangam ceremony decoration",
      subImage: [
        {
          imageOne: wedHomeImg3,
          imageTwo: wedHomeImg4,
          imageThree: wedHomeImg5,
          imageFour: wedHomeImg8,
        }
      ]
    },
    {
      id: 7,
      title: "Vidaai Decoration",
      image: wedHomeImg1,
      rating: 4.6,
      reviews: 125,
      currentPrice: 2199,
      originalPrice: 2599,
      discount: 15,
      description: "Emotional vidaai ceremony setup",
      subImage: [
        {
          imageOne: wedHomeImg2,
          imageTwo: wedHomeImg3,
          imageThree: wedHomeImg4,
          imageFour: wedHomeImg5,
        }
      ]
    },
    {
      id: 8,
      title: "Wedding Stage Decoration",
      image: wedHomeImg8,
      rating: 4.8,
      reviews: 205,
      currentPrice: 4599,
      originalPrice: 5299,
      discount: 13,
      description: "Stunning stage setup for wedding ceremonies",
      subImage: [
        {
          imageOne: wedHomeImg2,
          imageTwo: wedHomeImg3,
          imageThree: wedHomeImg4,
          imageFour: wedHomeImg5,
        }
      ]
    }
];

export default function WeddingHomeSection ({ onNavigate }) {
    return (
        <OneSectionDefault DataPackages={WeddingHomePageDataPackages} sectionTitle="Wedding Decoration" onNavigate={onNavigate} />
    )
}

export { WeddingHomePageDataPackages };
